/* eslint-disable */

import React from 'react';
import { CategoryNameCell } from '../ProductCategoryLicense';
import { LicenseAccessSelect } from './LicenseAccessSelect';

export function LicenseCategoryAccessSection({
  categories,
  categoryAccess,
  customCountByCategoryId = {},
  onAccessChange,
}) {
  return (
    <section className='license-form-section'>
      <div className='license-form-section-heading'>
        <h2 className='license-form-section-title'>กำหนดสิทธิ์ตามหมวดหมู่สินค้า</h2>
        <p className='license-form-section-caption'>
          กรุณาเลือกสิทธิ์การทำรายการซื้อ-ขาย สำหรับผลิตภัณฑ์แต่ละหมวดหมู่
        </p>
      </div>

      <div className='license-form-table-wrap'>
        <div className='license-form-table-head license-form-table-head--category'>
          <span>หมวดหมู่สินค้า (PRODUCT CATEGORY)</span>
          <span className='license-form-col-access'>กำหนดสิทธิ์การเข้าถึง</span>
        </div>
        {categories.map((category, index) => (
          <div
            key={category.id}
            className={`license-form-table-row${index % 2 === 0 ? ' license-form-table-row--striped' : ''}`}
          >
            <span className='license-form-row-name'>
              <CategoryNameCell category={category} />
            </span>
            <LicenseAccessSelect
              value={categoryAccess[category.id]}
              customCount={customCountByCategoryId[category.id] || 0}
              onChange={(value) => onAccessChange(category.id, value)}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
